$(document).ready(function () {
  $('[data-tiles-slider]').each(function () {
    const $track = $(this);
    const desktopItems = parseInt($track.data('desktopItems'), 10) || 3;
    const tabletItems = Math.max(1, desktopItems - 1);
    const margin = 20;
    const peek = 0.2;
    const totalTiles = $track.find('.tiles-slider__tile').length;

    const section = $track.closest('.tiles-slider')[0];
    const scrollbarWrapper = section.querySelector('.tiles-slider__scrollbar');
    const scrollbarTrack = section.querySelector('.tiles-slider__scrollbar-track');
    const scrollbarThumb = section.querySelector('.tiles-slider__scrollbar-thumb');

    function getBaseItems() {
      const vw = window.innerWidth;
      if (vw >= 1100) return desktopItems;
      if (vw >= 750) return tabletItems;
      return 1;
    }

    function getVisibleItems() {
      const base = getBaseItems();
      return totalTiles > base ? base + peek : totalTiles;
    }

    function setTileWidths() {
      const stageOuter = $track.find('.owl-stage-outer')[0] || $track[0];
      const availableWidth = stageOuter.offsetWidth;
      if (!availableWidth) return;

      const hasOverflow = totalTiles > getBaseItems();
      const visibleItems = getVisibleItems();

      const marginCount = hasOverflow ? Math.floor(visibleItems) : totalTiles - 1;
      const tileWidth = Math.floor(
        (availableWidth - marginCount * margin) / visibleItems
      );

      $track.find('.tiles-slider__tile').css('width', tileWidth + 'px');
    }

    function updateScrollbarVisibility() {
      scrollbarWrapper.classList.toggle('is-active', totalTiles > getBaseItems());
    }

    function updateLastItemMargin() {
      const hasOverflow = totalTiles > getBaseItems();
      $track.find('.owl-item').last().css('margin-right', hasOverflow ? '' : '0');
    }

    setTileWidths();
    updateScrollbarVisibility();

    if (scrollbarTrack && scrollbarThumb) {
      const scrollbar = new OwlCarouselScrollbar($track, scrollbarTrack, scrollbarThumb);
      scrollbar.init();
    }

    $track.on('initialized.owl.carousel', function () {
      updateLastItemMargin();
    });

    $track.on('resize.owl.carousel', function () {
      setTileWidths();
      updateScrollbarVisibility();
    });

    $track.on('resized.owl.carousel', function () {
      updateLastItemMargin();
    });

    $track.addClass('owl-carousel').owlCarousel({
      autoWidth: true,
      margin: margin,
      loop: false,
      nav: false,
      dots: false,
      mouseDrag: true,
      touchDrag: true,
    });
  });
});
